module.exports = {"LOGIN":{"LOGIN_BUTTON":"LOG IN","USERNAME":"E-mail","PASSWORD":"Password","LOGIN_MIN_LENGTH":"Minimum length is 3 symbols.","LOGIN_MAX_LENGTH":"Maximum length is 50 symbols.","PASSWORD_MAX_LENGTH":"Maximum length is 50 symbols.","EXPIRED_LOGOUT":"Your session has expired. Please log in again."}}


//////////////////
// WEBPACK FOOTER
// ./src/dashboard/app/core/translate/translations/en/login.json
// module id = 696
// module chunks = 0